import { getCompanies, getCurrentCompany, setCompanyRequest } from '@/app/api';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { fetchClaims } from './claimsSlice';
import { ICompany } from '../types/company/types';
import { fetchStartet } from './startetSlice';
import { fetchCases } from './casesSlice';
import { fetchSearchData } from './searchSlice';

interface CompanyState {
  companies: ICompany[];
  currentCompany: ICompany | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: CompanyState = {
  companies: [],
  currentCompany: null,
  status: 'idle',
  error: null,
};

export const fetchCompanies = createAsyncThunk(
  'company/fetchCompanies',
  async () => {
    const response = await getCompanies();
    return response;
  }
);

export const fetchCurrentCompany = createAsyncThunk(
  'company/fetchCurrentCompany',
  async () => {
    const response = await getCurrentCompany();
    return response;
  }
);

export const setCompany = createAsyncThunk(
  'company/setCompany',
  async (companyId: number, { dispatch }) => {
    await setCompanyRequest(companyId);
    dispatch(fetchCurrentCompany());
    dispatch(refreshAppData());
  }
);

export const refreshAppData = createAsyncThunk(
  'app/refreshData',
  async (_, { dispatch }) => {
    await dispatch(fetchClaims());
    await dispatch(fetchStartet());
    await dispatch(fetchCases());
    await dispatch(fetchSearchData());
  }
);

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanies.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(
        fetchCompanies.fulfilled,
        (state, action: PayloadAction<ICompany[]>) => {
          state.status = 'succeeded';
          state.companies = action.payload;
        }
      )
      .addCase(fetchCompanies.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Error fetching companies';
      })
      .addCase(
        fetchCurrentCompany.fulfilled,
        (state, action: PayloadAction<ICompany>) => {
          state.currentCompany = action.payload;
        }
      );
  },
});

export default companySlice.reducer;
